module.exports = __webpack_public_path__ + "media/images/carbon-emissions-bg-51ab122707eb57e9b1641e2b3a62a228.png";